<template>
    <el-dialog :title="title" :visible.sync="visible" width="500px" :close-on-click-modal="false">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-form-item label="所属上级栏目" prop="pid">
                <el-select v-model="form.pid" placeholder="请选择上级栏目" style="width: 100%">
                    <el-option label="产品中心" value="1" />
                    <el-option label="解决方案" value="2" />
                    <el-option label="关于我们" value="3" />
                    <el-option label="购买渠道" value="4" />
                    <el-option label="招聘" value="5" />
                </el-select>
            </el-form-item>
            <el-form-item label="栏目名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入栏目名称"></el-input>
            </el-form-item>
            <el-form-item label="url" prop="url">
                <el-input v-model="form.url" placeholder="请输入url"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="handleConfirm">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { add, edit } from "@/api/content/footer";
export default {
    data() {
        return {
            title: "新增栏目",
            visible: false,
            form: {
                name: "",
                status: "1",
            },
            rules: {
                pid: [{ required: true, message: "请选择上级栏目" }],
                name: [{ required: true, message: "请输入栏目名称" }],
                url: [{ required: true, message: "请输入url" }],
            },
        };
    },
    methods: {
        open(row) {
            this.visible = true;
            if (row) {
                this.title = "编辑栏目";
                this.form = {
                    name: row.name,
                    pid: row.pid,
                    url: row.url,
                    uuid: row.uuid,
                };
            } else {
                this.title = "新增栏目";
                this.form = {
                    name: "",
                    pid: "",
                    url: "",
                };
                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            }
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                };
                if (this.form.uuid) {
                    edit(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("编辑成功");
                            this.visible = false;
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("编辑成功");
                            this.visible = false;
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
